<template>
  <div class="tble">
    <div class="mb10 flex flex-between">
      <div>
        <el-input
          size="small"
          clearable
          class="mr10 ipt"
          v-model.trim="keyWord"
          placeholder="请输入门店名称"
        ></el-input>
        <el-button size="small" type="primary" @click="search">查询</el-button>
      </div>

      <div>
        <el-button size="small" type="primary">修改门店OKR</el-button>
      </div>
    </div>
    <el-table
      :data="tableData"
      row-key="id"
      border
      ref="table"
      height="600px"
      default-expand-all
      :header-cell-style="{ background: '#E4E4E4', color: '#606266' }"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
    >
      <el-table-column prop="date" label="门店" width="280" fixed>
        <template slot-scope="scope">
          {{ scope.row.date }}
          <span
            class="add-wrapper"
            style="display: inline-block"
            @click="add(scope.row, scope.$index)"
          >
            <span class="hmicon icon-hao pointer"></span>
          </span>
          <span
            class="minus-wrapper"
            style="display: inline-block"
            @click="del(scope.row, scope.$index)"
          >
            <span class="hmicon icon-jianhao pointer"></span>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="总计" width="180" fixed>
      </el-table-column>

      <el-table-column
        :prop="v.prop"
        :label="v.month"
        v-for="(v, i) in monthList"
        :key="i"
        width="200"
      >
        <template slot-scope="scope" slot="header">
          <div class="flex flex-column flex-between">
            <div class="bm flex flex-center">
              {{ v.month }}
            </div>
            <div class="flex flex-center">1</div>
          </div>
        </template>
        <template slot-scope="scope">
          <div class="flex flex-center">
            <el-input
              size="small"
              clearable
              class="mr10 ipt"
              maxlength="38"
              style="width: 150px"
              v-model.trim="scope.row.drawNamerrr"
              placeholder="请输入"
            ></el-input>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <hm-shop-goods-okr
      type="microShop"
      :visible="dialogVisible"
      @saveGoods="saveGoods"
      @close="dialogVisible = false"
    ></hm-shop-goods-okr>
  </div>
</template>

<script>
import HmShopGoodsOkr from "@/components/HmShopGoodsOkr";
export default {
  components: { HmShopGoodsOkr },
  props: {
    data: {
      default: function() {
        return [];
      },
      type: Array
    }
  },
  data() {
    return {
      keyWord: "",
      dialogVisible: false,
      tableType: "",
      returnedItem: {},
      monthList: [],
      tableData: this.data,
      addTable: {
        id: 3333,
        date: "2016-05-0222333",
        name: "王小虎",
        address: "上海市普陀区金沙江路 1519 弄"
      },
      row: {}
    };
  },
  computed: {},
  watch: {
    data(val) {
      this.tableData = val;
    }
  },
  created() {
    this.monthList = [];
    for (let i = 1; i <= 12; i++) {
      this.monthList.push({
        month: i + "月",
        prop: "address",
        weight: 1
      });
    }
  },
  mounted() {},
  methods: {
    search() {
      // console.log(this.keyWord);
    },
    saveGoods() {
      if (this.row.hasOwnProperty("children")) {
        this.row.children.push(this.addTable);
      } else {
        this.row.children = [];
        this.row.children.push(this.addTable);
      }
    },
    add(row) {
      this.dialogVisible = true;
      this.row = row;
      // if (row.hasOwnProperty("children")) {
      //   row.children.push(this.addTable);
      // } else {
      //   row.children = [];
      //   row.children.push(this.addTable);
      // }
    },
    del(row) {
      //   this.deleteLazyTableItem(row);
      //   console.log(this.find(this.tableData, row.id));

      this.find(this.tableData, row.id);
      // this.$set(this.$refs.table.store.states.lazyTreeNodeMap, row.id, []);
    },
    find(arr, id) {
      this.returnedItem = {};
      arr.forEach((item, index) => {
        //利用foreach循环遍历
        if (item.id == id) {
          //判断递归结束条件
          //   console.log("returnedItem", item);
          //   console.log("arr", arr);
          if (item.children && item.children.length > 0) {
            this.$confirm(" 该节点下存在子节点,是否确定删除?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            }).then(() => {
              arr.splice(index, 1);
            });
          } else {
            arr.splice(index, 1);
          }
          //   this.returnedItem = item;
          return item;
        } else if (item.children && item.children.length > 0) {
          //判断chlidren是否有数据

          this.find(item.children, id); //递归调用
        }
      });
    }
  }
};
</script>
<style lang="scss">
.tble {
  .bm {
    border-bottom: 1px solid #ebeef5;
  }
}
</style>

<style lang="scss" scoped>
.bm {
  border-bottom: 1px solid #ebeef5;
}
</style>
